module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vbassets/_next/static/images/UPPAbaby-81f3292804415755a4240a4c1510111c.svg";